angular.module('ContactDetailsModule', [])
    .controller('ContactDetailsController', ['$scope', '$log', 'contactDetailsService', '$rootScope', 'contactService', '$jobviteUrls', 'constantService',
        function ($scope, $log, contactDetailsService, $rootScope, contactService, $jobviteUrls, constantService) {
            $scope.currencyMap = window.currencyMap;
            $scope.currencyData = {};
            $scope.lazyLoading = {};
            $scope.contactDetailsConsent = {};
            $scope.contactDetailsConsent = window.contactDetailsConsent;
            $scope.tagEditMode = false;
            $scope.showSeekConsentModal = false;
            $scope.modalDialogElement = 'jv-modalDialog';
            $scope.newTags = '';
            $scope.tagList = startingTagList;
            $scope.currencyMap = window.currencyMap;
            $scope.currencyData = {};
            $scope.resetModals = function () {
                $scope.modals = {
                    shareContact: false,
                    addToReq: {
                        show: false
                    },
                    sendJobviteError: false,
                    seekConsent: false
                };
            };
            $scope.resetModals();

            var url = $jobviteUrls.source + '/contact/LIRSCFrame.html?contactEid=' + $('#contactIds').val();
            $scope.liRscFrameurl = url;

            $scope.unLinkLinkedInProfile = function (memberToken, unlink) {
                var contactEid = $('#contactIds').val();
                contactService.unlinkLinkedInProfile({
                    contactEid: contactEid,
                    memberToken: memberToken,
                    unlink: unlink
                });
            };

            $scope.showLinkedInSyncErrorIcon = false;
            $scope.linkedInSyncStatus = function () {
                var contactId = $('#contactIds').val();
                contactService.getLinkedInCandidateSyncStatus({
                    contactEid: contactId
                }, function (result) {
                    if (result) {
                        angular.forEach(result, function (syncDetails) {
                            if (syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT') {
                                $scope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                                $scope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                            }
                        });
                    }
                });
            };

            $scope.linkedInSyncStatus();

            $scope.refreshLinkedInSync = function () {
                var contactId = $('#contactIds').val();
                contactService.syncCandidateToLinkedIn({
                    contactEid: contactId
                }, function (result) {
                    if (result) {
                        angular.forEach(result, function (syncDetails) {
                            if (syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT') {
                                $scope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                                $scope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                            }
                        });
                    }
                });
            };

            $scope.hideModals = function () {
                $scope.resetModals();
            };

            $scope.hideShareContactModal = function () {
                $scope.hideModals();
                $scope.$broadcast('SHARE_CONTACT_HIDING_MODAL');
            };

            $scope.hideAddToReqModal = function () {
                $scope.resetModals();
            };

            function showModal(modal) {
                $scope.modals[modal] = true;
            }

            $scope.showLoading = function () {
                $('#' + this.modalDialogElement).html('<center><img src="/__assets__/images/ajax-loader.gif?v=01425514829" style="padding-top: 50%" /></center>');
                $('#' + $scope.modalDialogElement).jqmShow();
            };

            $scope.hideLoading = function () {
                $('#' + this.modalDialogElement).jqmHide();
            };

            $scope.shareContact = function () {
                //Spoke to Carlos and Ali. Removing the option to download the resume. More corner cases to cover in that case. 
                // TODO-PRANAV: Remove this later on. 
                // contactDetailsService.getShareContact(args,function(result){
                //  if(result.response==undefined){
                //      $scope.shareData.resumeName = result.resume;
                //      $scope.shareData.resumeSize = result.fileSize;
                //      $scope.shareData.downloadResumeUrl = jvUrls.source + '/action/person/contactDetailsPage?action=doDownload&ids='+contactEid+'&contactAttributeIds='+result.eId;
                //      showModal('shareContact');
                //  }
                // });
                //this.$emit('SHARE_CONTACT_MODAL', 'SHOW');
                showModal('shareContact');
            };

            $scope.showSeekConsentModalOnClick = function () {
                showModal('seekConsent');
            };

            $scope.hideSeekConsentModal = function () {
                $scope.hideModals();
                $scope.$broadcast('SEEK_CONSENT_HIDING_MODAL');
            };

            $scope.exportData = function () {

                var contactName = $('#contactName').text().trim();
                if (!contactName) {
                    contactName = i18n['CONTACT'];
                }

                var data = {
                    id: $('#contactIds').val(),
                    type: 'ContactDataExport',
                    name: contactName
                };
                window.localStorage.setItem('fileDownloadParams', JSON.stringify(data));

                var win = window.open($jobviteUrls.jhire + '/htm/common/bulkDownloadFile.html', '_blank');
                win.blur();
            };

            // $scope.sendVideoInterview = function() {
            //  //VID-ENGAGE: Encapsulate in a service maybe. 
            //     var promise = VideoInterviewInviteModalService.inviteContacts(JV.CONTACT_IDS);
            //     promise.then(function(ifVideoInterviewInviteSent) {
            //         if (ifVideoInterviewInviteSent === true) {
            //          $log.info('Video Interview for Contact sent successfully');
            //         }
            //     })
            // };

            $scope.$on('SHARE_CONTACT_MODAL_HIDE_ALL', function (event, nessage) {
                $scope.hideModals();
                $scope.$broadcast('SHARE_CONTACT_HIDING_MODAL');
            });

            $scope.addToRequisition = function () {
                //Need to add page loading image
                //allowedAddToReq: Prerequisite for adding a contact to requisition. Current condition is that the contact should have first name, last name and email 
                if (allowedAddToReq === 'false') {
                    window.JV.Modal.show($('#jv-addReqError').html(), false);
                } else if (allowedAddWithEmail === 'false') {
                    window.JV.Modal.show($('#jv-addReqErrorForEmail').html(), false);
                } else {
                    contactDetailsService.getReqsFilters(function (result) {
                        $rootScope.$broadcast('AddToRequisitionModal', result);
                    });
                }
            };

            $scope.addToEmailCampaign = function () {
                $scope.modals.emailCampaign = true;
            };

            $scope.completeAddToEmailCampaign = function (campaign) {
                //Need to add page loading image
                contactService.performAction({
                    eids: $('#contactIds').val(),
                    action: 'campaign',
                    content: campaign
                }, function (response) {
                    var message = (response && response.data) ? response.data : null;
                    window.JV.Util.showMessage(message || constantService.ADDED_TO_CAMPAIGN.format(contactService.selectedEidslength, campaign.name || 'the campaign'));
                });
            };

            $scope.sendJobvite = function () {
                if ($scope.contactHasEmailAddress) {
                    window.JV.Person.process('sendJobvite');
                } else {
                    showModal('sendJobviteError');
                }
            };

            $rootScope.$on('REQUISITTION_SELECTED_ID', function (ev, results) {
                var obj = [];
                if (!!results.selectedReqEId) {
                    $.each(results.selectedReqEId, function (key, value) {
                        if (!!value && value && !!key) {
                            obj.push(key);
                        }
                    });
                    var args = {
                        ids: obj,
                        eids: $('#ids').val()
                    };
                    $scope.noOfRequisitions = (!!obj) ? obj.length : 0;
                    //Need to add page loading image

                    contactDetailsService.addToRequisition(args, function (result) {
                        $scope.hideAddToReqModal();
                        if (result != null && !!result.status && result.status === 200 && !!result.data) {
                            var data = result.data;
                            contactDetailsService.getApplications();
                            //DetailsTab.prototype.getApplications();
                            if (!!data.added && data.added === 1) {
                                window.JV.Util.showMessage(i18n['JV_CONTACTDETAILS_CTRL_THE_CONTACT_IS_ADDED_TO_THE_REQUISITION']);
                            } else if (!!data.added && data.added > 1) {
                                window.JV.Util.showMessage(i18n['JV_CONTACTDETAILS_CTRL_THE_CONTACT_IS_ADDED_TO_0_REQUISITIONS'].format(data.added));
                            } else {
                                window.JV.Util.showMessage(i18n['JV_CONTACTDETAILS_CTRL_CONTACT_WAS_NOT_ADDED_TO_THE_REQUISITION_S_PLEASE_'].format(data.added));
                            }
                        } else {
                            window.JV.Util.showMessage(i18n['JV_CONTACTDETAILS_CTRL_CONTACT_WAS_NOT_ADDED_TO_THE_REQUISITION_S_PLEASE_']);
                        }
                    });
                }
            });

            $scope.contactHasEmailAddress = !!$('#emailId').val();

            $scope.addTags = function () {
                if ($('#tagsContainer').is(':visible') === false) {
                    $('#tagsContainer').slideToggle();
                }
                $scope.tagEditMode = true;
            };

            $scope.cancelAddTags = function () {
                $scope.newTags = '';
                $scope.tagEditMode = false;
            };

            var tagSearchUrl = window.jvUrls.source + '/action/person/contactList';

            $scope.tagSelect = contactDetailsService.tagSelect;

            $scope.saveTags = function () {

                var _tags = [];

                // get the existing tags
                $('.existingTag').each(function () {
                    _tags.push($(this).text());
                });

                // and add the new tags
                $.each($scope.newTags, function (index, value) {
                    //Sending the original tag entered by the user to the backend: value.id (value.name has escaped value now)
                    _tags.push(value.id);
                });

                // and call the saveTags service method
                var args = {
                    tagNames: _tags,
                    'ids': $('#contactIds').val()
                };

                if (args.tagNames.length === 0) {
                    args.tagNames = '';
                }

                //Need to add page loading image

                contactDetailsService.saveTags(args, function (result) {
                    $scope.tagEditMode = false;
                    $scope.newTags = '';
                    if (result != null && !!result.status && result.status === 200) {
                        window.JV.Util.showMessage(i18n['JV_CONTACTDETAILS_CTRL_TAG_UPDATED']);
                        if(result && result.data && result.data.resultList && result.data.resultList.length > 0) {
                          $scope.tagList = result.data.resultList;
                        }
                    } else {
                        $scope.$root.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                    }
                });
            };

            $scope.removeTag = function (tagName) {
                var _tags = [];
                tagName = tagName.replace('&#39;', '\''); // handle escaped single quotes

                // get all the existing tags but this one
                $('.existingTag').each(function () {
                    var existingTag = $(this).text();
                    if (existingTag != tagName) {
                        _tags.push($(this).text());
                    }
                });

                // and call the saveTags service method
                var args = {
                    tagNames: _tags,
                    'ids': $('#contactIds').val()
                };

                if (args.tagNames.length === 0) {
                    args.tagNames = '';
                }

                //Need to add page loading image

                contactDetailsService.saveTags(args, function (result) {
                    $scope.tagEditMode = false;
                    if (result != null && !!result.status && result.status === 200) {
                        window.JV.Util.showMessage(i18n['JV_CONTACTDETAILS_CTRL_TAG_UPDATED']);
                        $scope.tagList = _tags;
                    } else {
                        $scope.$root.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                    }
                });
            };

            //Enabling/Disabling Email Notification Preference
            //Adding this code as module here, as it need to execute once all initial data/event loaded
            (function () {
                var bouncePrefix = 'BOUNCE_';
                var elmNotifyPreference = $("select[name='details.notifyPref']");
                var PRIMARY_EMAIL_ID = '#jv-Email0';
                var originalEmailValue = $('#jv-primaryEmail').val();
                var originalEmailStatus = elmNotifyPreference.val();

                if (originalEmailStatus.startsWith(bouncePrefix)) {
                    var getUpdatedPrimaryEmail = function () {
                        return $(PRIMARY_EMAIL_ID).val();
                    };
                    //if primary email is update by change/set as primary/delete actions
                    var updateEmailNotifyPreference = function (updatePrimaryEmail) {
                        if (updatePrimaryEmail !== originalEmailValue) {
                            elmNotifyPreference.prop('disabled', true);
                            var valueToSelect = originalEmailStatus.substring(7);
                            if (elmNotifyPreference.val() !== valueToSelect) {
                                window.JV.bounceEmailPre ? elmNotifyPreference.val(window.JV.bounceEmailPre) : elmNotifyPreference.val(valueToSelect);
                                elmNotifyPreference.trigger('change');
                            }
                        } else {
                            elmNotifyPreference.attr('disabled', '');
                            window.JV.bounceEmailPre ? elmNotifyPreference.val(window.JV.bounceEmailPre) : elmNotifyPreference.val(originalEmailStatus);
                        }
                    };

                    var bindEmailActions = function (elements) {
                        if (angular.isDefined(elements) && elements.length) {
                            setTimeout(function () {
                                updateEmailNotifyPreference(getUpdatedPrimaryEmail());
                            });
                        }
                    };

                    $('td.jv-emailContainer').on('click', 'ul > li[key="SET_PRIMARY"], a.jv-deleteEmail', function (event) {
                        bindEmailActions($(event.target));
                    });

                    $('td.jv-emailContainer').on('keyup', PRIMARY_EMAIL_ID, function () {
                        if (window.JV.isStatusFlagEnabled) {
                            updateEmailNotifyPreference(this.value);
                        }
                    });

                    elmNotifyPreference.on('change', function () {
                        if ($(this).val().startsWith(bouncePrefix)) {
                            $(this).next().show();
                        } else {
                            $(this).next().hide();
                        }
                    });
                }
            }());

            // --- Enhanced logic to handle Source field dynamically (mirroring JV.NewPerson.js) ---
            let sourceChangeTimeout;
            // Helper function
            function loadPersonHelper(selectedText, selectedSource, page) {
                var argsObj = {
                    action: 'getPerson',
                    q: selectedText,
                    personType: selectedSource,
                    url: JV.GET_REQUISITION_URL,
                    page: page
                };
                JV.Modal.render(argsObj, null, false);
            }

            // Helper to get roles by sourceKind
            function getRolesBySourceKind(sourceKind) {
                switch (sourceKind) {
                    case 'EnteredByRecruiter':
                        return ['Recruiter', 'Research'];
                    case 'EnteredByHiringManager':
                        return ['HiringManager'];
                    default:
                        return [];
                }
            }

            // --- Block all AJAX calls to /person/contactDetails.html for internal source types ---
            $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
                var $selected = $('#jv-sourceIds').find(':selected');
                var sourceKind = $selected.attr('jvsourceTypeKind');
                if (
                    options.url &&
                    options.url.indexOf('/person/contactDetails.html') !== -1 &&
                    window.JV &&
                    JV.Person &&
                    JV.Person.Source &&
                    JV.Person.Source.isInternalSourceType &&
                    JV.Person.Source.isInternalSourceType(sourceKind) &&
                    ['EnteredByRecruiter', 'EnteredByHiringManager', 'EnteredForEmployee', 'EmployeeEntered', 'Referral'].includes(sourceKind)
                ) {
                    jqXHR.abort();
                }
            });

            $(document).ready(function() {
                var sourceFieldSelector = '#jv-sourceIds';
                $(document).off('change', sourceFieldSelector).on('change', sourceFieldSelector, function(event) {
                    var $selected = $('#jv-sourceIds').find(':selected');
                    var sourceKind = $selected.attr('jvsourceTypeKind');
                    var selectedText = $('#jv-personText').val();
                    var page = 0;
                    var roles = getRolesBySourceKind(sourceKind);
                    if (window.JV && JV.Person && JV.Person.Source && JV.Person.Source.isInternalSourceType(sourceKind)) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        loadPersonHelper(selectedText, roles, page);
                        return false;
                    }
                });

                // Modal search bar Enter key and Search button handler
                let personSearchDebounce;
                $(document).on('keyup', '#jv-personText', function (e) {
                    if ((e.keyCode === 13 || e.which === 13) && $('#jv-modalDialog').is(':visible')) {
                        clearTimeout(personSearchDebounce);
                        const searchText = $(this).val();
                        var page = 0;
                        var $selected = $('#jv-sourceIds').find(':selected');
                        var sourceKind = $selected.attr('jvsourceTypeKind');
                        var roles = getRolesBySourceKind(sourceKind);
                        personSearchDebounce = setTimeout(() => {
                            loadPersonHelper(searchText, roles, page);
                        }, 100);
                    }
                });
                $(document).on('click', '#jv-searchPersonButton', function (e) {
                    if ($('#jv-modalDialog').is(':visible')) {
                        clearTimeout(personSearchDebounce);
                        const searchText = $('#jv-personText').val();
                        var page = 0;
                        var $selected = $('#jv-sourceIds').find(':selected');
                        var sourceKind = $selected.attr('jvsourceTypeKind');
                        var roles = getRolesBySourceKind(sourceKind);
                        personSearchDebounce = setTimeout(() => {
                            loadPersonHelper(searchText, roles, page);
                        }, 100);
                    }
                });
            });
        }
    ]);
